module.exports = __webpack_public_path__ + "img/onboarding-qutoe.34def8fc.svg";